<template>
  <div>
    <v-snackbar class="pt-6 pr-6" style="z-index: 6 !important" transition="slide-x-reverse-transition"
      v-model="snackbar" timeout="2000" :value="true" :color="snaclr" absolute outlined top right>
      <v-icon class="mr-2" :color="snaclr">mdi-alert-outline</v-icon>
      {{ snackmsgbar }}
    </v-snackbar>

    <div class="ml-14 mr-14 mt-14">
      <v-card elevation="0" class="pa-1">
        <v-toolbar dense class="elevation-0 pl-0">
          <v-toolbar-title class="font-weight-bold title ml-0 mt-2">
            REKYC Request
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <div class="ml-2">
            <v-select v-model="activeTab" :items="requestTypeOptions" item-text="label" item-value="value"
              label="Request type" dense outlined hide-details class="rounded-lg" style="max-width: 180px"
              @change="onTabChange"></v-select>
          </div>

          <v-menu v-model="dateMenu" :close-on-content-click="false" transition="scale-transition" offset-y
            min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="dateRangeText" prepend-inner-icon="mdi-calendar-outline" readonly dense outlined
                hide-details v-bind="attrs" v-on="on" class="rounded-lg ml-2" style="min-width: 260px; max-width: 280px"></v-text-field>
            </template>
            <v-date-picker v-model="dateRange" range no-title @change="onDateChange"></v-date-picker>
          </v-menu>

          <div class="ml-2">
            <v-text-field dense solo flat label="Search" outlined class="elevation-0 rounded-lg" v-model="tabledata"
              hide-details prepend-inner-icon="mdi-magnify" style="max-width: 200px"></v-text-field>
          </div>

          <v-btn icon color="primary" class="ml-1" @click="getRekycData">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </v-toolbar>

        <v-divider class="mt-3"></v-divider>

        <v-row class="mt-3" no-gutters>
          <v-col cols="4" class="pa-2">
            <v-card class="stat-card text-center elevation-0" @click="selectStat(0)"
              :class="{ 'stat-active': activeTab === 0 }">
              <p class="font-weight-regular mt-4 mb-0 grey--text text--darken-1">Request</p>
              <p class="mt-1 mb-3 font-weight-bold display-1 primary--text">
                {{ counts.view !== null ? counts.view : 0 }}
              </p>
            </v-card>
          </v-col>
          <v-col cols="4" class="pa-2">
            <v-card class="stat-card text-center elevation-0" @click="selectStat(1)"
              :class="{ 'stat-active': activeTab === 1 }">
              <p class="font-weight-regular mt-4 mb-0 grey--text text--darken-1">Complete</p>
              <p class="mt-1 mb-3 font-weight-bold display-1 green--text text--darken-2">
                {{ counts.complete !== null ? counts.complete : 0 }}
              </p>
            </v-card>
          </v-col>
          <v-col cols="4" class="pa-2">
            <v-card class="stat-card text-center elevation-0" @click="selectStat(2)"
              :class="{ 'stat-active': activeTab === 2 }">
              <p class="font-weight-regular mt-4 mb-0 grey--text text--darken-1">Reject</p>
              <p class="mt-1 mb-3 font-weight-bold display-1 red--text text--darken-2">
                {{ counts.reject !== null ? counts.reject : 0 }}
              </p>
            </v-card>
          </v-col>
        </v-row>

        <v-data-table :loading="tableload" :headers="headers" :items="filteredData"
          class="brd elevation-0 mt-7" disable-sort outlined fixed-header height="calc(100vh - 280px)"
          :items-per-page="50" :footer-props="{ 'items-per-page-options': [50, 100, 200, -1] }">
          <template v-slot:[`item._category`]="{ item }">
            <span class="cat-chip" :class="categoryClass(item._category)">{{ item._category }}</span>
          </template>

          <template v-slot:[`item.app_status`]="{ item }">
            <div class="d-flex align-center">
              <span class="status-chip" :class="statusClass(item.app_status)">{{ item.app_status }}</span>
              <v-tooltip v-if="item.rejected_reason" bottom content-class="rkyc-tooltip" max-width="320">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" color="red" class="ml-2 cursor-pointer" size="18">
                    mdi-information-outline
                  </v-icon>
                </template>
                <div>
                  <p class="mb-1 font-weight-bold">Rejected Reason:</p>
                  <p class="mb-1">{{ item.rejected_reason }}</p>
                  <p v-if="item.rejection_date_time" class="mb-0 caption">
                    Date: {{ item.rejection_date_time }}
                  </p>
                </div>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </div>
</template>

<script>
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export default {
  data() {
    return {
      activeTab: -1,
      tabFilters: ['view', 'com', 'rej'],
      tabKeys: ['view', 'complete', 'reject'],
      requestTypeOptions: [
        { label: 'All', value: -1 },
        { label: 'Request', value: 0 },
        { label: 'Complete', value: 1 },
        { label: 'Reject', value: 2 }
      ],
      tabledata: '',
      searchTimer: null,
      tableload: false,
      snackbar: false,
      snackmsgbar: '',
      snaclr: '#000',
      dateMenu: false,
      dateRange: [],
      defaultRangeApplied: false,
      statusFilter: null,
      requestFilter: null,
      branchFilterValue: null,
      counts: {
        view: null,
        complete: null,
        reject: null
      },
      rawData: []
    };
  },
  computed: {
    currentCount() {
      if (this.activeTab === -1) {
        return (this.counts.view || 0) + (this.counts.complete || 0) + (this.counts.reject || 0);
      }
      const key = this.tabKeys[this.activeTab];
      return this.counts[key] !== null ? this.counts[key] : 0;
    },
    headers() {
      const base = [
        { text: 'Date', value: 'date_time' },
        // { text: 'Mobile', value: 'mobile_no' },
        { text: 'Client Id', value: 'client_id' },
        { text: 'Name', value: 'client_name' },
        { text: 'Branch Id', value: 'branch_id' },
        // { text: 'DP code', value: 'dp_code' },
        // { text: 'PanNumber', value: 'client_pan' },
        { text: 'Request', value: 'request_type' },
        // { text: 'E-signed datetime', value: 'esigned_datetime' },
        { text: 'Status', value: 'app_status' }
      ];
      if (this.activeTab === 1) {
        base.push({ text: 'Approval Date & Time', value: 'approval_date_time' });
      } else if (this.activeTab === 2) {
        base.push({ text: 'Rejection Date & Time', value: 'rejection_date_time' });
      } else if (this.activeTab === -1) {
        base.splice(base.length - 1, 0, { text: 'Type', value: '_category' });
        base.push({ text: 'Approval Date & Time', value: 'approval_date_time' });
        base.push({ text: 'Rejection Date & Time', value: 'rejection_date_time' });
      }
      return base;
    },
    dateRangeText() {
      if (!this.dateRange || this.dateRange.length === 0) return '';
      if (this.dateRange.length === 1) return this.dateRange[0];
      return `${this.dateRange[0]} ~ ${this.dateRange[1]}`;
    },
    statusOptions() {
      const set = new Set();
      this.rawData.forEach(d => { if (d.app_status) set.add(d.app_status); });
      return Array.from(set);
    },
    requestOptions() {
      const set = new Set();
      this.rawData.forEach(d => { if (d.request_type) set.add(d.request_type); });
      return Array.from(set);
    },
    branchOptions() {
      const set = new Set();
      this.rawData.forEach(d => { if (d.branch_id) set.add(d.branch_id); });
      return Array.from(set).sort();
    },
    filteredData() {
      return this.rawData;
    }
  },
  watch: {
    tabledata() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.getRekycData();
        this.getCounts();
      }, 400);
    }
  },
  methods: {
    parseDate(str) {
      if (!str) return null;
      const parts = str.split('/');
      if (parts.length !== 3) return null;
      return new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
    },
    statusClass(status) {
      if (!status) return '';
      if (status.includes('completed')) return 'status-completed';
      if (status.includes('pending')) return 'status-pending';
      if (status.includes('reject')) return 'status-rejected';
      return '';
    },
    categoryClass(cat) {
      if (cat === 'Request') return 'cat-request';
      if (cat === 'Complete') return 'cat-complete';
      if (cat === 'Reject') return 'cat-reject';
      return '';
    },
    onTabChange() {
      this.getRekycData();
    },
    selectStat(idx) {
      this.activeTab = idx;
      this.getRekycData();
    },
    onDateChange() {
      if (this.dateRange && this.dateRange.length === 2) {
        if (new Date(this.dateRange[0]) > new Date(this.dateRange[1])) {
          this.dateRange = [this.dateRange[1], this.dateRange[0]];
        }
        this.dateMenu = false;
        this.getRekycData();
      }
    },
    setDefaultDateRange() {
      const today = new Date();
      const weekAgo = new Date();
      weekAgo.setDate(today.getDate() - 6);
      const fmt = (d) => {
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${y}-${m}-${day}`;
      };
      this.dateRange = [fmt(weekAgo), fmt(today)];
    },
    getRekycData() {
      this.tableload = true;
      this.rawData = [];
      const axios = require('axios');
      const payload = {
        from: this.dateRange && this.dateRange.length === 2 ? this.dateRange[0] : '',
        to: this.dateRange && this.dateRange.length === 2 ? this.dateRange[1] : '',
        search_term: this.tabledata ? this.tabledata.trim() : ''
      };
      const brcode = localStorage.getItem('brcode');
      const axiosThis = this;

      if (this.activeTab === -1) {
        const slugs = ['view', 'com', 'rej'];
        const keys = ['view', 'complete', 'reject'];
        const tagLabels = ['Request', 'Complete', 'Reject'];
        Promise.all(
          slugs.map((s) => axios.post('https://rekycbe.mynt.in/dashboard?filter=&limit=100&offset=1', { tab: s, ...payload }, {
            headers: { 'Content-Type': 'application/json' }
          }))
        ).then((responses) => {
          axiosThis.tableload = false;
          let merged = [];
          responses.forEach((response, idx) => {
            if (response.data && response.data.data) {
              const filtered = brcode
                ? response.data.data.filter((item) => item.branch_id === brcode)
                : response.data.data;
              axiosThis.counts[keys[idx]] = filtered.length;
              merged = merged.concat(filtered.map((item) => ({ ...item, _category: tagLabels[idx] })));
            }
          });
          axiosThis.rawData = merged.map((item) => ({
            ...item,
            esigned_datetime: item['e-signed-datetime'] || item.e_sigh_datetime || ''
          }));
        }).catch((error) => {
          console.log(error);
          axiosThis.tableload = false;
          axiosThis.snackbar = true;
          axiosThis.snackmsgbar = error.message || 'Request failed';
          axiosThis.snaclr = 'error';
        });
        return;
      }

      const filter = this.tabFilters[this.activeTab];
      const countKey = this.tabKeys[this.activeTab];
      const config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: 'https://rekycbe.mynt.in/dashboard?filter=&limit=100&offset=1',
        headers: { 'Content-Type': 'application/json' },
        data: { tab: filter, ...payload }
      };
      axios.request(config)
        .then((response) => {
          axiosThis.tableload = false;
          if (response.data && response.data.data) {
            const filtered = brcode
              ? response.data.data.filter((item) => item.branch_id === brcode)
              : response.data.data;
            axiosThis.rawData = filtered.map((item) => ({
              ...item,
              esigned_datetime: item['e-signed-datetime'] || item.e_sigh_datetime || ''
            }));
            axiosThis.counts[countKey] = filtered.length;
          } else {
            axiosThis.snackbar = true;
            axiosThis.snackmsgbar = 'No data';
            axiosThis.snaclr = 'error';
          }
        })
        .catch((error) => {
          console.log(error);
          axiosThis.tableload = false;
          axiosThis.snackbar = true;
          axiosThis.snackmsgbar = error.message || 'Request failed';
          axiosThis.snaclr = 'error';
        });
    },
    getCounts() {
      const axios = require('axios');
      const pairs = [
        { slug: 'view', key: 'view' },
        { slug: 'com', key: 'complete' },
        { slug: 'rej', key: 'reject' }
      ];
      const payload = {
        from: this.dateRange && this.dateRange.length === 2 ? this.dateRange[0] : '',
        to: this.dateRange && this.dateRange.length === 2 ? this.dateRange[1] : '',
        search_term: this.tabledata ? this.tabledata.trim() : ''
      };
      const brcode = localStorage.getItem('brcode');
      pairs.forEach(({ slug, key }) => {
        axios.post('https://rekycbe.mynt.in/dashboard?filter=&limit=100&offset=1', { tab: slug, ...payload }, {
          headers: { 'Content-Type': 'application/json' }
        })
          .then((response) => {
            if (response.data && response.data.data) {
              const filtered = brcode
                ? response.data.data.filter((item) => item.branch_id === brcode)
                : response.data.data;
              this.counts[key] = filtered.length;
            }
          })
          .catch(() => { });
      });
    },
    verifyClient(item) {
      this.snackbar = true;
      this.snaclr = 'primary';
      this.snackmsgbar = `Verify ${item.client_id}`;
    },
    downloadExcel() {
      const dataForExcel = this.filteredData.map(item => ({
        'Date': item.date_time,
        'Mobile': item.client_mobile,
        'Client Id': item.client_id,
        'Name': item.client_name,
        'Branch Id': item.branch_id,
        'DP Code': item.dp_code,
        'PanNumber': item.client_pan,
        'Request': item.request_type,
        'E-signed Datetime': item.e_sigh_datetime,
        'Status': item.app_status
      }));
      const worksheet = XLSX.utils.json_to_sheet(dataForExcel);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
      const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([wbout], { type: 'application/octet-stream' });
      saveAs(blob, 'rekyc-request-data.xlsx');
    }
  },
  mounted() {
    this.setDefaultDateRange();
    this.getRekycData();
    this.getCounts();
  }
};
</script>

<style scoped>
.brd {
  border: 1px solid #E0E0E0;
}

.stat-card {
  border: 1px solid #E0E0E0;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.stat-card:hover {
  border-color: #3B82F6;
}

.stat-active {
  border: 2px solid #3B82F6 !important;
  background-color: #EFF6FF !important;
}

.rekyc-tabs >>> .v-tab {
  min-width: auto;
  padding: 0 16px;
  letter-spacing: 0;
  color: #6B7280 !important;
}

.rekyc-tabs >>> .v-tab--active {
  color: #3B82F6 !important;
}

.rkyc-count {
  background-color: #3B82F6;
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
  border-radius: 999px;
  padding: 2px 10px;
  min-width: 26px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.rkyc-tooltip {
  background-color: #000 !important;
  color: #fff !important;
}

.cursor-pointer {
  cursor: pointer;
}

.status-chip {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.3px;
  white-space: nowrap;
  text-transform: lowercase;
}

.status-chip::first-letter {
  text-transform: uppercase;
}

.status-completed {
  background-color: #DCFCE7;
  color: #15803D;
  border: 1px solid #86EFAC;
}

.status-pending {
  background-color: #FEF3C7;
  color: #B45309;
  border: 1px solid #FCD34D;
}

.status-rejected {
  background-color: #FEE2E2;
  color: #B91C1C;
  border: 1px solid #FCA5A5;
}

.cat-chip {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  white-space: nowrap;
}

.cat-request {
  background-color: #DBEAFE;
  color: #1D4ED8;
  border: 1px solid #93C5FD;
}

.cat-complete {
  background-color: #DCFCE7;
  color: #15803D;
  border: 1px solid #86EFAC;
}

.cat-reject {
  background-color: #FEE2E2;
  color: #B91C1C;
  border: 1px solid #FCA5A5;
}
</style>
